import React from "react";
import PropTypes from "prop-types";

import menu_bookmark from "images/custom/topbar/menu_bookmark.png";
import TopbarMenu from "components/Topbar/TopbarMenu/TopbarMenu";

import { slide as Menu } from "react-burger-menu";

import { SHOW_TOPIC_CATEGORIES, SHOW_CHALLENGE_CATEGORIES } from "config";
import localize from "lang/localize";

const propTypes = {
  showMenu: PropTypes.bool.isRequired,
  handleShowMenu: PropTypes.func.isRequired,
  handleHideMenu: PropTypes.func.isRequired,
  state: PropTypes.string,
  loggedIn: PropTypes.bool,
  projectId: PropTypes.number,
  project: PropTypes.object,
  topic: PropTypes.object,
  topicsList: PropTypes.array,
  challenge: PropTypes.object,
  handleOpenSearchChallengeDialog: PropTypes.func,
  handleOpenSelectTopicCategoryDialog: PropTypes.func,
  handleOpenTopicsListDialog: PropTypes.func,
  handleOpenTourModal: PropTypes.func,
  handleOpenShareGameDialog: PropTypes.func,
  handleRefresh: PropTypes.func.isRequired,
  language: PropTypes.string,
  isMobileProjectPage: PropTypes.bool
};

class NinjavilleTopbarMenu extends TopbarMenu {
  openOrCloseMenu() {
    if (this.props.showMenu) {
      this.props.handleHideMenu();
    } else {
      this.props.handleShowMenu();
    }
  }

  render() {
    let showChallengeCategories =
      (this.props.state === "topic" ||
        this.props.state === "topic-comments-thread" ||
        this.props.state === "challenge-category") &&
      this.props.topic &&
      Array.isArray(this.props.topic.categories) &&
      this.props.topic.categories.length > 0;

    let showFirstDivider = SHOW_CHALLENGE_CATEGORIES
      ? showChallengeCategories
      : false;

    let showTopicCategories =
      (this.props.state === "projecthome" ||
        this.props.state === "home-single" ||
        this.props.state === "topic-category") &&
      this.props.project &&
      Array.isArray(this.props.project.categories) &&
      this.props.project.categories.length > 0;

    let showTopicsList =
      this.props.project &&
      Array.isArray(this.props.topicsList) &&
      this.props.topicsList.length > 0;

    let showSearchChallenges =
      this.props.project &&
      this.props.project.challengeSearchEnabled &&
      !this.props.isMobileProjectPage === true;

    let showShareGame =
      this.props.project &&
      this.props.project.projectShareLink &&
      this.props.projectId;

    let showReferAFriend =
      this.props.project &&
      this.props.project.projectReferralLink &&
      (this.props.state === "projecthome" ||
        this.props.state === "home-single" ||
        this.props.state === "topic-category" ||
        this.props.state === "project" ||
        this.props.state === "topic" ||
        this.props.state === "topic-comments-thread" ||
        this.props.state === "challenge" ||
        this.props.state === "challenge-category" ||
        this.props.state === "challenge-comments" ||
        this.props.state === "challenge-comments-thread" ||
        this.props.state === "challenge-subpage" ||
        this.props.state === "claim-comments" ||
        this.props.state === "claim-comments-thread");

    /* The pages below (this.props.state) have a route to original Project */
    let showBackToProject =
      this.props.projectId &&
      (this.props.state === "topic" ||
        this.props.state === "topic-comments-thread" ||
        this.props.state === "challenge" ||
        this.props.state === "project" ||
        this.props.state === "topic-category" ||
        this.props.state === "challenge-category" ||
        this.props.state === "challenge-comments" ||
        this.props.state === "challenge-comments-thread" ||
        this.props.state === "challenge-subpage" ||
        this.props.state === "claim-comments" ||
        this.props.state === "claim-comments-thread" ||
        this.props.state === "login-tour");

    let showSecondDivider = SHOW_TOPIC_CATEGORIES
      ? showSearchChallenges ||
        showShareGame ||
        showBackToProject ||
        showTopicCategories
      : showSearchChallenges || showShareGame || showBackToProject;

    let projectTitle = this.props.project ? this.props.project.title : "";

    /*
      Fragments do not seem to work well with React Burger Menu,
      so the render() method looks a little messy now with a lot of
      this.props.loggedIn checks
    */
    return (
      <Menu
        isOpen={this.props.showMenu}
        handleHideMenu={this.props.handleHideMenu}
        onStateChange={this.toggleMenu}
        styles={this.setStyles()}
        right
      >
        {/* Custom: Menu Bookmark icon for opening menu */}
        <a
          className="menu-bookmark"
          href="/menu"
          onClick={e => {
            e.preventDefault();
            this.openOrCloseMenu();
          }}
        >
          <img
            src={menu_bookmark}
            alt={localize("ninjaville_menu", this.props.language)}
          />
        </a>

        {/* You should be able to select categories without logging in */}
        {this.renderChallengeCategoriesItem(showChallengeCategories)}
        {this.renderDivider(showFirstDivider)}
        {this.renderTopicCategoriesItem(showTopicCategories)}
        {this.renderTopicsListItem(showTopicsList)}
        {/* Logged in links */}
        {this.renderSearchChallengesItem(showSearchChallenges)}
        {this.renderShareGameItem(showShareGame)}
        {this.renderReferAFriendItem(showReferAFriend)}
        {this.renderBackToProjectItem(showBackToProject, projectTitle)}
        {this.renderDivider(showSecondDivider)}
        {this.renderRefreshItem()}
        {this.renderSettingsItem()}
        {this.renderAboutTourItem()}
        {this.renderLogoutItem()}
        {/* Logged out links */}
        {this.renderLoginItem()}
      </Menu>
    );
  }
}

NinjavilleTopbarMenu.propTypes = propTypes;

export default NinjavilleTopbarMenu;
